import { envConfig } from '~/utils/env';
import { BaseRestRepository } from './baseRestRepository';

const BASE_URL = `${envConfig.service.subscriptions}/company-portal/onboarding-experience`;

export interface CustomerSuccessContactDto {
  name: string;
  email: string | null;
  phone: string | null;
  profilePictureUrl: string | null;
  title: string | null;
}

export interface OnboardingTodoItemDto {
  id: string;
  title: string;
  description: string | null;
  sortOrder: number;
  links: string[];
  done: boolean;
  addedAt: string;
  completedAt: string | null;
}

export interface OnboardingTodoCategoryDto {
  id: string;
  title: string;
  sortOrder: number;
  items: OnboardingTodoItemDto[];
}

export interface CompanyPortalOnboardingExperienceDto {
  currentlyOnboarding: boolean;
  onboardingCompletedAt: string | null;
  customerSuccessContact: CustomerSuccessContactDto | null;
  categories: OnboardingTodoCategoryDto[];
}

export class OnboardingExperienceRepository extends BaseRestRepository {
  public async getExperience(): Promise<CompanyPortalOnboardingExperienceDto> {
    const response = await this.fetchWithAuth(BASE_URL, {}, false);
    return this.getJsonResponse(response);
  }
}

export const onboardingExperienceRepository = new OnboardingExperienceRepository();
